export const ofhrReportCommercialDataTitle = "Commercial Data";
export const ofhrReportTechnicalDataTitle = "Technical Data";
export const ofhrReportCommercialDatesOverlaping =
  "Commercial Dates Overlaping";
export const ofhrReportTechnicalDatesDifferent =
  "Technical Dates Different from Commercial";
